jQuery( document ).ready( function ( $ ) {
	function EVENTSGMAP( context, id ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-events v3' )
		this.geocoder = ''
		//are we in china, because if we are we need to use open maps instead of google maps
		this.gmom = context.attr( 'data-gmom' )
		this.id = id
		this.context = context // ID of target element
		this.map = ''
		this.init()
	}

	/**
	 * gets open map coords from an address
	 */
	EVENTSGMAP.prototype.getCoords = function () {
		var self = this

		const address = self.context.attr( 'data-address' )

		$.get( 'https://nominatim.openstreetmap.org/search?format=json&q=' + address, function ( data ) {
			// console.log( 'location data:: ', data )
			self.renderOpenMap( data )
		} )
	}

	EVENTSGMAP.prototype.renderOpenMap = function ( coords ) {
		var self = this
		var location = [ coords[ 0 ].lat, coords[ 0 ].lon ]
		// Creating map options
		var mapOptions = {
			center: location,
			zoom: 16,
		}

		// Creating a map object
		var map = new L.map( self.id, mapOptions )

		// Creating a Layer object
		var layer = new L.TileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' )

		L.marker( location ).addTo( map )

		// Adding layer to the map
		map.addLayer( layer )
	}


	EVENTSGMAP.prototype.init = function () {
		const self = this

		if ( self.gmom == 'open' ) {
			self.getCoords()
		} else {
			self.geocoder = new google.maps.Geocoder()
			var latlng = new google.maps.LatLng( -34.397, 150.644 )
			var mapOptions = {
				zoom: 16,
				center: latlng,
			}
			self.map = new google.maps.Map( document.getElementById( self.id ), mapOptions )
			self.codeAddress()
		}


	}

	EVENTSGMAP.prototype.codeAddress = function () {
		const self = this
		var address = document.getElementById( self.id ).getAttribute( 'data-address' )

		self.geocoder.geocode( { 'address': address }, function ( results, status ) {
			if ( status == 'OK' ) {
				self.map.setCenter( results[ 0 ].geometry.location )
				new google.maps.Marker( {
					map: self.map,
					position: results[ 0 ].geometry.location,
				} )
			} else {
				console.warn( 'Geocode was not successful for the following reason: ' + status )
			}
		} )
	}

	// Check EVENTSGMAP is used on this page before instantiating
	if ( $( '.wp-block-jtf-jtf-events' ).length > 0 ) {
		// instantiate a new google maps API for each gmap block
		$( '.jtf__eventsblock--gmap' ).each( function () {
			const id = $( this ).attr( 'id' )
			new EVENTSGMAP( $( this ), id )
		} )
	}
} )

